import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Canvas from "./pages/Canvas";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    document.title = "Ali Eldhaw — Portfolio";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Canvas mode="view" />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
